// import React from 'react'

// export default function TopInfoBar() {
//     return (
//         <div className="w-full bg-blue-900 text-white text-sm">
//             <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row 
//                             items-center justify-center gap-2 md:gap-6
//                             py-1 md:py-2">

//                 {/* CONTACT INFO */}
//                 <div className="flex flex-col md:flex-row md:flex-nowrap justify-center items-center gap-2 md:gap-6 w-full">

//                     {/* Email */}
//                     <div className="group flex items-center gap-1 md:gap-2 px-2 md:px-3 py-1 md:py-2 rounded-md
//                                     hover:bg-blue-50 transition-all duration-200 cursor-pointer">
//                         <span className="text-white font-medium group-hover:text-black transition-colors duration-200">
//                             Email ID -
//                         </span>
//                         <a
//                             href="mailto:ho@murshidabaddccb.bank.in"
//                             className="text-white font-semibold group-hover:text-blue-600 transition-colors duration-200"
//                         >
//                             ho@murshidabaddccb.bank.in
//                         </a>
//                     </div>

//                     {/* Contact No */}
//                     <div className="group flex items-center gap-1 md:gap-2 px-2 md:px-3 py-1 md:py-2 rounded-md
//                                     hover:bg-blue-50 transition-all duration-200 cursor-pointer">
//                         <span className="text-white font-medium group-hover:text-black transition-colors duration-200">
//                             Contact No. -
//                         </span>
//                         <a
//                             href="tel:+917605071507"
//                             className="text-white font-semibold group-hover:text-blue-600 transition-colors duration-200"
//                         >
//                             +91 7605071507
//                         </a>
//                     </div>

//                     {/* RBI License */}
//                     <div className="group flex flex-row items-center gap-1 md:gap-2 px-2 md:px-3 py-1 md:py-2 rounded-md
//                                     hover:bg-blue-50 transition-all duration-200 cursor-pointer text-center md:text-left whitespace-nowrap">
//                         <span className="text-white font-medium group-hover:text-black transition-colors duration-200">
//                             RBI License No. -
//                         </span>
//                         <span className="text-white font-semibold group-hover:text-blue-600 transition-colors duration-200">
//                             RBI Licence Number: RPCD(KOL) No. 10-C, Dated - 30/04/2012
//                         </span>
//                     </div>

//                 </div>
//             </div>
//         </div>
//     )
// }



// import React from 'react'

// export default function TopInfoBar() {
//     return (
//         <div className="w-full bg-blue-900 text-white text-sm">
//             <div className="max-w-7xl mx-auto px-4 py-1 md:py-2 flex flex-col md:flex-row items-center justify-center md:justify-center gap-2 md:gap-6">

//                 {/* MOBILE VERSION */}
//                 <div className="flex md:hidden w-full justify-between items-center px-2">
//                     {/* Email */}
//                     <a
//                         href="mailto:ho@murshidabaddccb.bank.in"
//                         className="text-white font-medium text-sm"
//                     >
//                         ho@murshidabaddccb.bank.in
//                     </a>

//                     {/* Contact No */}
//                     <a
//                         href="tel:+917605071507"
//                         className="text-white font-medium text-sm"
//                     >
//                         +91 7605071507
//                     </a>
//                 </div>

//                 {/* DESKTOP VERSION */}
//                 <div className="hidden md:flex flex-row md:flex-nowrap justify-center items-center gap-2 md:gap-6 w-full">

//                     {/* Email */}
//                     <div className="group flex items-center gap-2 px-3 py-2 rounded-md
//                                     hover:bg-blue-50 transition-all duration-200 cursor-pointer">
//                         <span className="text-white font-medium group-hover:text-black transition-colors duration-200">
//                             Email ID -
//                         </span>
//                         <a
//                             href="mailto:ho@murshidabaddccb.bank.in"
//                             className="text-white font-semibold group-hover:text-blue-600 transition-colors duration-200"
//                         >
//                             ho@murshidabaddccb.bank.in
//                         </a>
//                     </div>

//                     {/* Contact No */}
//                     <div className="group flex items-center gap-2 px-3 py-2 rounded-md
//                                     hover:bg-blue-50 transition-all duration-200 cursor-pointer">
//                         <span className="text-white font-medium group-hover:text-black transition-colors duration-200">
//                             Contact No. -
//                         </span>
//                         <a
//                             href="tel:+917605071507"
//                             className="text-white font-semibold group-hover:text-blue-600 transition-colors duration-200"
//                         >
//                             +91 7605071507
//                         </a>
//                     </div>

//                     {/* RBI License */}
//                     <div className="group flex flex-row items-center gap-2 px-3 py-2 rounded-md
//                                     hover:bg-blue-50 transition-all duration-200 cursor-pointer text-center md:text-left whitespace-nowrap">
//                         <span className="text-white font-medium group-hover:text-black transition-colors duration-200">
//                             RBI Licence No. -
//                         </span>
//                         <span className="text-white font-semibold group-hover:text-blue-600 transition-colors duration-200">
//                             RPCD(KOL) No. 10-C, Dated - 30/04/2012
//                         </span>
//                     </div>

//                 </div>
//             </div>
//         </div>
//     )
// }


import React from 'react'

export default function TopInfoBar() {
    return (
        <div className="w-full bg-blue-900 text-white text-sm">
            <div className="max-w-7xl mx-auto px-4 py-1 md:py-2 flex flex-col md:flex-row items-center md:justify-between gap-2 md:gap-6">

                {/* MOBILE VERSION */}
                <div className="flex md:hidden w-full justify-between items-center px-2">
                    {/* Email */}
                    <a
                        href="mailto:ho@murshidabaddccb.bank.in"
                        className="text-white font-medium text-sm hidden min-[375px]:inline"
                    >
                        ho@murshidabaddccb.bank.in
                    </a>

                    {/* Contact No */}
                    <a
                        href="tel:+917605071507"
                        className="text-white font-medium text-sm ml-auto"
                    >
                        +91 7605071507
                    </a>
                </div>

                {/* DESKTOP VERSION */}
                <div className="hidden md:flex flex-row items-center justify-between w-full">

                    {/* Left Section: Email + Contact */}
                    <div className="flex items-center gap-6">

                        {/* Email */}
                        <div className="group flex items-center gap-2 px-3 py-2 rounded-md
                                        hover:bg-blue-50 transition-all duration-200 cursor-pointer">
                            <span className="text-white font-medium group-hover:text-black transition-colors duration-200">
                                Email ID -
                            </span>
                            <a
                                href="mailto:ho@murshidabaddccb.bank.in"
                                className="text-white font-semibold group-hover:text-blue-600 transition-colors duration-200"
                            >
                                ho@murshidabaddccb.bank.in
                            </a>
                        </div>

                        {/* Contact No */}
                        <div className="group flex items-center gap-2 px-3 py-2 rounded-md
                                        hover:bg-blue-50 transition-all duration-200 cursor-pointer">
                            <span className="text-white font-medium group-hover:text-black transition-colors duration-200">
                                Contact No. -
                            </span>
                            <a
                                href="tel:+917605071507"
                                className="text-white font-semibold group-hover:text-blue-600 transition-colors duration-200"
                            >
                                +91 7605071507
                            </a>
                        </div>
                    </div>

                    {/* Right Section: RBI License */}
                    <div className="group flex flex-row items-center gap-2 px-3 py-2 rounded-md
                                    hover:bg-blue-50 transition-all duration-200 cursor-pointer text-center md:text-left whitespace-nowrap">
                        <span className="text-white font-medium group-hover:text-black transition-colors duration-200">
                            RBI Licence No. -
                        </span>
                        <span className="text-white font-semibold group-hover:text-blue-600 transition-colors duration-200">
                            RPCD(KOL) No. 10-C, Dated - 30/04/2012
                        </span>
                    </div>

                </div>
            </div>
        </div>
    )
}
